import { expertApi } from './endpoints/expert';
import { exportApi } from './endpoints/export';

export const { useLazyExportApplicationQuery } = exportApi;
export const { useLazyExpertsQuery } = expertApi;
